module.exports = __webpack_public_path__ + "static/media/logo.a09f8e4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 1152
// module chunks = 0